// This file was generated by lezer-generator. You probably shouldn't edit it.
export const AlertRuleSearch = 1,
  FilterExpression = 2,
  DataSourceToken = 3,
  FilterValue = 4,
  NameSpaceToken = 5,
  LabelToken = 6,
  GroupToken = 7,
  RuleToken = 8,
  StateToken = 9,
  TypeToken = 10,
  HealthToken = 11,
  DashboardToken = 12,
  PluginsToken = 13,
  ContactPointToken = 14,
  RuleSourceToken = 15,
  FreeFormExpression = 16,
  Dialect_dataSourceFilter = 0,
  Dialect_nameSpaceFilter = 1,
  Dialect_labelFilter = 2,
  Dialect_groupFilter = 3,
  Dialect_ruleFilter = 4,
  Dialect_stateFilter = 5,
  Dialect_typeFilter = 6,
  Dialect_healthFilter = 7,
  Dialect_dashboardFilter = 8,
  Dialect_pluginsFilter = 9,
  Dialect_contactPointFilter = 10,
  Dialect_sourceFilter = 11;
